import React from 'react';

const InputDate = ({name, label, value, onChange, placeholder, required}) => {
  return (
    <div className="InputDate wrap-adminInput">
      <label className="input-label" htmlFor={name}>{label}</label>
      <input className = "input-el" type="date" value = {value} onChange={onChange} name = {name} id = {name} required ={required}/>
    </div>
  );
}

export default InputDate;